import React from 'react';
import NumberCircle from '../NumberCircle';
import DOK from '../DOK';
import CustomFeedback from '../CustomFeedback';
import QuestionDependency from '../QuestionDependency';
import OptionalImage from '../../lessonPlayer/components/OptionalImage';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const ClozeDragDrop = ({ model, isManuscriptShort }) => {
  let body;
  if (model.body) {
    body = model.body.replaceAll('contenteditable', 'content');
  }

  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Question Type:</div>
        <div>Fill In The Blank Drag-Drop</div>
      </div>
      <div className='label-value-row'>
        <div>Question Number:</div>
        <div>{model.questionNumber}</div>
      </div>
      <div className='label-value-row'>
        <div>Point Value:</div>
        <div>{model.maxScore}</div>
      </div>
      <div className='label-value-row'>
        <div className='text-area-label'>Directions:</div>
        <div className='ckeditor-text text-area'><HtmlComponent htmlStr={model.questionText} /></div>
      </div>
      <OptionalImage model={model} />
      <div className='label-value-row'>
        <div className='text-area-label'>Text:</div>
        <div className='ckeditor-text text-area has-number-circles'><HtmlComponent htmlStr={body} /></div>
      </div>
      <div>
        {model.validation.prompts.map((prompt, idx) => {
          return (
            <React.Fragment key={prompt.id}>
              <div className='standalone-label has-number-circles'><NumberCircle number={idx + 1} />Accepted Answers:</div>
              <ul>
                {prompt.answers.map((answer) => {
                  return (
                    <li key={answer.id} className='ckeditor-text answer'><HtmlComponent htmlStr={answer.text} /></li>
                  );
                })}
              </ul>
            </React.Fragment>
          );
        })}
      </div>
      <div className='standalone-label'>Distractors:</div>
      <ul>
        {model.validation.distractors && model.validation.distractors.map((distractor) => {
          return (
            <li key={distractor.id} className='ckeditor-text answer'><HtmlComponent htmlStr={distractor.text} /></li>
          );
        })}
      </ul>
      {/* advanced options */}
      {!isManuscriptShort && (
        <>
          <QuestionDependency model={model} />
          <div className='label-value-row'>
            <div>Extra Class:</div>
            <div>{model.extraClass}</div>
          </div>
          <div className='label-value-row'>
            <div>Student Answer Format:</div>
            <div>{model.responseFormat}</div>
          </div>
          <div className='label-value-row'>
            <div>Auto-scored:</div>
            <div>{model.autoScore.toString()}</div>
          </div>
          <div className='label-value-row'>
            <div>Numbered Blanks:</div>
            <div>{(model.numberedBlanks) ? 'ON' : 'OFF'}</div>
          </div>
        </>
      )}
      <CustomFeedback model={model} />
      <div className='label-value-row'>
        <div>Hint:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.hint} /></div>
      </div>
      <div className='label-value-row'>
        <div>Solution:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.validation.solution} /></div>
      </div>
      {!isManuscriptShort && (
        <>
          <div className='label-value-row'>
            <div>Survey Question:</div>
            <div>{(model.survey) ? 'ON' : 'OFF'}</div>
          </div>
          <div className='label-value-row'>
            <div>Do Not Score:</div>
            <div>{(model.unscored) ? 'ON' : 'OFF'}</div>
          </div>
          <DOK model={model} />
        </>
      )}
    </div>
  );
};

export default ClozeDragDrop;
